// import React from 'react'

import { InputGroup } from 'react-bootstrap'

// const ZariInputGroup = props => {
//   return <InputGroup {...props} />
// }

export default InputGroup
